import React, { useEffect } from 'react';

import { Header, Footer, Services, Solutions, Ourexperience, Whychooseus, Ourpricing, Latestwork, SoftwareShowcase } from '../containers';
import { Navbar, Cta } from "../components";
import ContactForm from "../components/contactform/ContactForm";
import StatsBar from '../components/credibility/StatsBar';
import ClientLogos from '../components/credibility/ClientLogos';
import Testimonials from '../components/credibility/Testimonials';
import Seo from '../seo/Seo';
import { SITE } from '../seo/site.mjs';
import { organizationSchema, websiteSchema, webPageSchema } from '../seo/schemas';

const HOME_TITLE = 'Desarrollo de software y facturación electrónica en República Dominicana';

const HomePage = () => {
    useEffect(() => {
        // Reinitialize WOW.js for scroll animations on route change
        if (window.WOW) {
            new window.WOW({ mobile: false }).init();
        }
    }, []);

    return (
        <>
            <Seo
                title={HOME_TITLE}
                description={SITE.defaultDescription}
                path="/"
                jsonLd={[
                    organizationSchema(),
                    websiteSchema(),
                    webPageSchema({ path: '/', title: `${HOME_TITLE} | ${SITE.name}`, description: SITE.defaultDescription }),
                ]}
            />
            <Navbar />
            <Header />
            <StatsBar />
            <Services />
            <Solutions />
            <SoftwareShowcase />
            <ClientLogos />
            <Whychooseus />
            <Ourexperience />
            <Testimonials />
            <Cta />
            <Latestwork />
            <Ourpricing />
            <ContactForm />
            <Footer />
        </>
    );
};

export default HomePage;
